/*eslint-disable multiline-ternary */
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  PlaceHolderBulbSVG,
  SuccessCircle,
  ErrorCircle,
} from '../../../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
import { showNetworkName } from '../../../../../utils/common';

const ProviderInformationTab = ({
  locationHandler,
  doctorDetails,
  addressIndex,
  selectAffiliationsTab,
  affiliatedDoctorsAddress,
  ...otherProps
}) => {
  const {
    searchProviderParams: { Network },
    address,
    networksList,
    networkTierList,
  } = useSelector(({ priceCompareAdmin }) => priceCompareAdmin);
  const { Find_Provider_Network } = useSelector(
    (state) => state?.app?.customNetwork,
  );

  const {
    Value_Network_For_PriceComparison_Admin,
    Display_Network_Indicator_for_Price_Comparison_page,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);

  let uniqueTier = [];
  const inNetworkList = [];

  if (Value_Network_For_PriceComparison_Admin === 'network') {
    if (doctorDetails.DoctorAfflFacilities[addressIndex].Networks?.length > 0) {
      const doctorNetwork =
        doctorDetails.DoctorAfflFacilities[addressIndex].Networks;
      doctorNetwork.forEach((eachNetwork) => {
        if (
          networkTierList.findIndex((ele) => ele.value === eachNetwork) !== -1
        ) {
          inNetworkList.push(eachNetwork);
        }
      });
    }
  }

  if (Value_Network_For_PriceComparison_Admin === 'tier') {
    const tierArr = [];
    if (doctorDetails.DoctorAfflFacilities[addressIndex].Networks?.length > 0) {
      const doctorNetwork =
        doctorDetails.DoctorAfflFacilities[addressIndex].Networks;
      networkTierList.forEach((eachNetwork) => {
        if (
          doctorNetwork.findIndex(
            (ele) => ele === eachNetwork.NetworkDescription,
          ) !== -1
        ) {
          tierArr.push(eachNetwork.NetworkTier);
        }
      });
      uniqueTier = [...new Set(tierArr)];
      uniqueTier.sort();
    }
  }

  const googleAddress =
    doctorDetails.DoctorAfflFacilities?.length > 0 &&
    doctorDetails.DoctorAfflFacilities[addressIndex].Coordinateds
      ? doctorDetails.DoctorAfflFacilities[addressIndex].Coordinateds
      : '';
  const googleURL = `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${googleAddress}`;
  const formattingPhone = (phone) => {
    const Number = phone && phone.toString();
    if (Number) {
      if (Number.includes('-')) {
        const splitNumber = Number && Number.split('-');
        return (
          splitNumber &&
          `(${splitNumber[0]}) ${splitNumber[1]}-${splitNumber[2]}`
        );
      } else {
        const splitStrings = [];
        for (let i = 0; i < Number.length; i += 3) {
          splitStrings.push(Number.slice(i, i + 3));
        }
        return (
          splitStrings.length > 0 &&
          `(${splitStrings[0]}) ${splitStrings[1]}-${splitStrings[2]}${splitStrings[3]}`
        );
      }
    } else return;
  };
  return (
    <>
      <div className="provider-information find-provider-bottom-border">
        <Row className="primary-background row m-0 p-0 py-4 mt-4">
          <Col sm={12} className="p-0">
            <Row>
              <Col sm={4} className="phone-info pl-5">
                <p className="primary-text paragraph-font phone-info-heading mb-1">
                  {t('find_provider.phone')}
                </p>
                {doctorDetails?.Phone1 || doctorDetails?.Phone2 ? (
                  <>
                    {doctorDetails?.Phone1 !== '' && (
                      <a
                        className="secondary-text paragraph-font"
                        href={`tel:${doctorDetails?.Phone1}`}
                      >
                        {formattingPhone(doctorDetails?.Phone1)}
                      </a>
                    )}
                    <br />
                    {doctorDetails?.Phone2 !== '' && (
                      <a
                        className="secondary-text paragraph-font"
                        href={`tel:${doctorDetails?.Phone2}`}
                      >
                        {formattingPhone(doctorDetails?.Phone2)}
                      </a>
                    )}
                  </>
                ) : doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1 ||
                  doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2 ? (
                  <>
                    {doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.Phone1 !== '' && (
                      <a
                        className="secondary-text paragraph-font"
                        href={`tel:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone1}`}
                      >
                        {formattingPhone(
                          doctorDetails?.DoctorAfflFacilities[addressIndex]
                            ?.Phone1,
                        )}
                      </a>
                    )}
                    <br />
                    {doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.Phone2 !== '' && (
                      <a
                        className="secondary-text paragraph-font"
                        href={`tel:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.Phone2}`}
                      >
                        {formattingPhone(
                          doctorDetails?.DoctorAfflFacilities[addressIndex]
                            ?.Phone2,
                        )}
                      </a>
                    )}
                  </>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              {(affiliatedDoctorsAddress?.BillingAddress ||
                (affiliatedDoctorsAddress?.FacilityServiceAddress &&
                  affiliatedDoctorsAddress?.FacilityServiceAddress.length >
                    0) ||
                (affiliatedDoctorsAddress?.FacilityMailingAddress &&
                  affiliatedDoctorsAddress?.FacilityMailingAddress.length >
                    0)) && (
                <Col sm={8} className="address-info">
                  <Row>
                    {(affiliatedDoctorsAddress?.BillingAddress ||
                      (affiliatedDoctorsAddress?.FacilityServiceAddress &&
                        affiliatedDoctorsAddress?.FacilityServiceAddress
                          .length > 0)) && (
                      <Col>
                        {affiliatedDoctorsAddress?.BillingAddress && (
                          <>
                            <p className="primary-text paragraph-font phone-info-heading mb-1">
                              {t('find_provider.provider_billing_address')}
                            </p>
                            {/*{doctorDetails.DoctorAfflFacilities &&
                doctorDetails.DoctorAfflFacilities.length ? ( */}
                            <p className="secondary-text paragraph-font">
                              {affiliatedDoctorsAddress?.BillingAddress
                                .Address1 &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  .Address1 + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                .Address2 &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  .Address2 + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                .Address3 &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  .Address3 + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                .BillingOfficeName &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  .BillingOfficeName + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress?.City &&
                                affiliatedDoctorsAddress?.BillingAddress?.City +
                                  ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                ?.County &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  ?.County + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                ?.State &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  ?.State + ', '}
                              {affiliatedDoctorsAddress?.BillingAddress
                                .PostalCode &&
                                affiliatedDoctorsAddress?.BillingAddress
                                  .PostalCode}
                            </p>
                          </>
                        )}
                        {affiliatedDoctorsAddress?.FacilityServiceAddress &&
                          affiliatedDoctorsAddress?.FacilityServiceAddress
                            .length > 0 && (
                            <>
                              <p className="primary-text paragraph-font phone-info-heading mb-1">
                                {t('find_provider.provider_service_address')}
                              </p>
                              {/*{doctorDetails.DoctorAfflFacilities &&
                doctorDetails.DoctorAfflFacilities.length ? ( */}
                              <p className="secondary-text paragraph-font">
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].Address1 &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].Address1 + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].Address2 &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].Address2 + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].Address3 &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].Address3 + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].City &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].City + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].County &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].County + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].State &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].State + ', '}
                                {affiliatedDoctorsAddress
                                  ?.FacilityServiceAddress[0].PostalCode &&
                                  affiliatedDoctorsAddress
                                    ?.FacilityServiceAddress[0].PostalCode}
                              </p>
                            </>
                          )}
                      </Col>
                    )}
                    {affiliatedDoctorsAddress?.FacilityMailingAddress &&
                      affiliatedDoctorsAddress?.FacilityMailingAddress.length >
                        0 && (
                        <Col>
                          <p className="primary-text paragraph-font phone-info-heading mb-1">
                            {t('find_provider.provider_mailing_address')}
                          </p>
                          {/*{doctorDetails.DoctorAfflFacilities &&
                doctorDetails.DoctorAfflFacilities.length ? ( */}
                          <p className="secondary-text paragraph-font">
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .Address1 &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].Address1 + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .Address2 &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].Address2 + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .Address3 &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].Address3 + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .City &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].City + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .County &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].County + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .State &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].State + ', '}
                            {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                              .PostalCode &&
                              affiliatedDoctorsAddress
                                ?.FacilityMailingAddress[0].PostalCode}
                          </p>
                        </Col>
                      )}
                  </Row>
                  {/*) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )} */}
                  {/*{doctorDetails?.DoctorAfflFacilities?.length > 1 && (
                  <Button
                    className=" p-0 m-0 paragraph-font secondary-2 cursor-pointer provider-location-link"
                    variant="link"
                    onClick={locationHandler}
                  >
                    Change Provider Location
                  </Button>
                )} */}
                </Col>
              )}
              {
                //<Col sm={4} className="pr-5">
                //<p className="secondary-text paragraph-font text-right">
                //<Link to={googleURL} target="_blank">
                //<span className="secondary-2">
                //{t('find_provider.directions')}
                //</span>
                //</Link>
                //<br />
                //{/*0.8 mile */}
                //{doctorDetails.DoctorAfflFacilities?.length > 0 &&
                //doctorDetails.DoctorAfflFacilities[addressIndex]
                //.Distance &&
                //`${
                //doctorDetails.DoctorAfflFacilities[addressIndex]
                //.Distance
                //} mile${
                //Number(
                //doctorDetails.DoctorAfflFacilities[addressIndex]
                //.Distance,
                //) > 1 && 's'
                //}`}
                //</p>
                //</Col>
              }
            </Row>
          </Col>
        </Row>
        <Row className="row m-0 p-0 pt-4 pb-4">
          <Col sm={12} className="p-0">
            <Row>
              <Col sm={4} className="patient-accept">
                <button
                  disabled
                  className={`${
                    doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.AcceptingNewPatients
                      ? 'accept-new-patient-success'
                      : 'accept-new-patient-danger'
                  } d-block`}
                >
                  <div className="d-flex align-items-center">
                    {doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.AcceptingNewPatients ? (
                      <>
                        <SuccessCircle className="success-circle" />
                        <span>{t('find_provider.accepting_new_patients')}</span>
                      </>
                    ) : (
                      <>
                        <ErrorCircle className="danger-circle" />
                        <span>
                          {t('find_provider.not')}{' '}
                          {t('find_provider.accepting_new_patients')}
                        </span>
                      </>
                    )}
                  </div>
                </button>

                {Display_Network_Indicator_for_Price_Comparison_page &&
                doctorDetails?.DoctorAfflFacilities[addressIndex]
                  .ShowNetwork ? (
                  <button
                    disabled
                    className={`${
                      doctorDetails?.DoctorAfflFacilities[addressIndex]
                        ?.InNetwork
                        ? 'in-network-success'
                        : 'in-network-danger'
                    } mt-2 d-block`}
                  >
                    <div className="d-flex align-items-center">
                      {doctorDetails?.DoctorAfflFacilities[addressIndex]
                        ?.InNetwork ? (
                        <>
                          <SuccessCircle className="success-circle" />
                          <span>{t('find_provider.in_network')}</span>
                        </>
                      ) : (
                        <>
                          <ErrorCircle className="danger-circle" />
                          <span>{t('find_provider.out_of_network')}</span>
                        </>
                      )}
                    </div>
                  </button>
                ) : (
                  ''
                )}
              </Col>
              <Col sm={4} className="">
                <div className="patient-satisfaction primary-background">
                  <p className="patient-satisfaction-lalbel mb-1">
                    {t('find_provider.patient_satisfaction')}
                  </p>
                  {doctorDetails?.DoctorAfflFacilities[addressIndex]
                    ?.PatientSatisfaction &&
                  doctorDetails?.DoctorAfflFacilities[addressIndex]
                    ?.PatientSatisfaction !== '' ? (
                    <p className="secondary-text paragraph-font">
                      {
                        doctorDetails?.DoctorAfflFacilities[addressIndex]
                          ?.PatientSatisfaction
                      }
                    </p>
                  ) : (
                    <p className="no-data">
                      {t('find_provider.data_not_available')}
                    </p>
                  )}
                </div>
              </Col>
              <Col sm={4} className="">
                <div className="primary-background provider-placeholder">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="pr-4">
                      <PlaceHolderBulbSVG className="placeholder-icon" />
                    </div>
                    <p className="placeholder-heading mb-0">
                      {t('find_provider.placeholder')}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      {Value_Network_For_PriceComparison_Admin === 'network' && (
        <>
          {doctorDetails?.DoctorAfflFacilities[addressIndex]?.InNetwork && (
            <div className="find-provider-bottom-border find-provider-network-info">
              <Row className="m-0 p-0 pt-4 pb-4 network-section">
                <Col sm={12} className="p-0 m-0">
                  <p className="w-100 primary-text paragraph-font provider-details-heading">
                    {t('find_provider.networks')}
                  </p>
                </Col>
                <Col sm={12} className="p-0">
                  <Row>
                    {inNetworkList?.length ? (
                      inNetworkList.map((item, index) => (
                        <Col sm={4} className="mb-2" key={index}>
                          <p className="provider-details-data">
                            <span>
                              {showNetworkName(Find_Provider_Network, item)}
                            </span>
                          </p>
                        </Col>
                      ))
                    ) : (
                      <Col sm={4} className="mb-2">
                        <p className="no-data">
                          {t('find_provider.data_not_available')}
                        </p>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </>
      )}

      {Value_Network_For_PriceComparison_Admin === 'tier' && (
        <>
          {doctorDetails?.DoctorAfflFacilities[addressIndex]?.InNetwork && (
            <div className="find-provider-bottom-border find-provider-network-info">
              <Row className="m-0 p-0 pt-4 pb-4 network-section">
                <Col sm={12} className="p-0 m-0">
                  <p className="w-100 primary-text paragraph-font provider-details-heading">
                    {t(
                      'member.price_comparison.provider_container.networks_dropdown_labelTier',
                    )}
                  </p>
                </Col>
                <Col sm={12} className="p-0">
                  <Row>
                    {uniqueTier?.length ? (
                      uniqueTier.map((item, index) => (
                        <Col sm={4} className="mb-2" key={index}>
                          <p className="provider-details-data">
                            <span>{item}</span>
                          </p>
                        </Col>
                      ))
                    ) : (
                      <Col sm={4} className="mb-2">
                        <p className="no-data">
                          {t('find_provider.data_not_available')}
                        </p>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </>
      )}

      <div className="provider-professional-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.professional_details')}
          </p>
          <Col sm={12} className="p-0">
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading">
                  {t('find_provider.specialties')}
                </p>
                {doctorDetails.DoctorAfflFacilities?.length &&
                doctorDetails.DoctorAfflFacilities[addressIndex]?.Specialties &&
                doctorDetails.DoctorAfflFacilities[addressIndex]?.Specialties
                  .length ? (
                  doctorDetails.DoctorAfflFacilities[
                    addressIndex
                  ].Specialties.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading">
                  {t('find_provider.medical_school_education')}
                </p>
                {doctorDetails.MedicalSchoolEducation &&
                doctorDetails.MedicalSchoolEducation.length ? (
                  doctorDetails.MedicalSchoolEducation.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading">
                  {t('find_provider.board_certification')}
                </p>
                {doctorDetails.BoardCertifications &&
                doctorDetails.BoardCertifications.length ? (
                  doctorDetails.BoardCertifications.map((item, index) => (
                    <p className="provider-details-data" key={index}>
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.experience')}
                </p>
                {doctorDetails.Experience ? (
                  <p className="provider-details-data">
                    {doctorDetails.Experience}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.awards_and_recognitions')}
                </p>
                {doctorDetails.AwardsAndRecognition ? (
                  <p className="provider-details-data">
                    {doctorDetails.AwardsAndRecognition}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.affiliations')}
                </p>
                {doctorDetails.DoctorAfflFacilities?.length > 0 ? (
                  <Button
                    className="provider-details-data-secondary cursor-pointer affiliations-button text-lowercase"
                    onClick={selectAffiliationsTab}
                    variant="link"
                  >
                    {`${doctorDetails.DoctorAfflFacilities.length} affiliation${
                      doctorDetails.DoctorAfflFacilities.length > 1 ? 's' : ''
                    }`}
                  </Button>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.license_type')}
                </p>
                {doctorDetails.LicenseType ? (
                  <p className="provider-details-data">
                    {doctorDetails.LicenseType}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.license_number')}
                </p>
                {doctorDetails.LicenseNumber ? (
                  <p className="provider-details-data">
                    {doctorDetails.LicenseNumber}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
              <Col sm={4}>
                <p className="provider-details-sub-heading mt-4">
                  {t('find_provider.national_provider_id')}
                </p>
                {doctorDetails.NationalProviderID ? (
                  <p className="provider-details-data">
                    {doctorDetails.NationalProviderID}
                  </p>
                ) : (
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="provider-office-hours-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.office_hours')}
          </p>
          <Col sm={12} className="p-0">
            {doctorDetails.DoctorAfflFacilities?.length &&
            doctorDetails.DoctorAfflFacilities[addressIndex]?.OfficeHours &&
            doctorDetails.DoctorAfflFacilities[addressIndex]?.OfficeHours
              .length ? (
              doctorDetails.DoctorAfflFacilities[addressIndex].OfficeHours.map(
                (item, index) => (
                  <p className="row mb-0" key={index}>
                    <span className="col-sm-2 provider-details-data">
                      {item.Day}
                    </span>
                    <span className="col-sm-4 hours-info">{item.Time}</span>
                  </p>
                ),
              )
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          <p className="w-100 primary-text paragraph-font provider-details-sub-heading mt-4">
            {t('find_provider.same_day_appointment')}
          </p>
          {doctorDetails?.DoctorAfflFacilities[addressIndex]
            ?.SameDayAppointment !== undefined ? (
            <p className="provider-details-data">
              {doctorDetails?.DoctorAfflFacilities[addressIndex]
                ?.SameDayAppointment
                ? 'Available'
                : 'Not Available'}{' '}
            </p>
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
      <div className="provider-facilities-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.facilities_location')}
          </p>
          {doctorDetails.DoctorAfflFacilities?.length &&
          doctorDetails.DoctorAfflFacilities[addressIndex]?.FacilitiesAtLocation
            ?.length ? (
            doctorDetails.DoctorAfflFacilities[
              addressIndex
            ].FacilitiesAtLocation.map((item, index) => (
              <p className="provider-details-data w-100 mb-2" key={index}>
                {item}
              </p>
            ))
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
    </>
  );
};

export default ProviderInformationTab;
